import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      paths: state => state.crumbs.paths
    })
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};